import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Ologies from './Ologies';
import { getGrades } from '../SchoolGradeOlogyApis';

const Wrapper = styled.div`
  color: #fff;
  padding: 30px 20px 20px 20px;
  background-color: var(--main-web-color);
  margin: 20px 0;
  margin-bottom: 0;
  border-bottom: 4px solid var(--bar-pink-border);

  a:hover {
    color: var(--bar-pink-border);
  }

  .ant-tabs {
    .ant-tabs-nav {
      ::before {
        border-color: var(--bar-pink-border);
      }
    }

    .ant-tabs-nav-list {
      width: 100%;

      .ant-tabs-tab {
        color: white;
        font-size: 18px;
      }

      .ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: white;
        }
      }

      .ant-tabs-ink-bar {
        background-color: var(--bar-pink-border);
        height: 4px !important;
      }
    }
  }
`;

const Title = styled.div`
  color: #fff;
  font-size: 24px;
  text-transform: uppercase;
  text-align: center;
  font-weight: 600;
  line-height: 1.5;
`;

const SubTitleWrapper = styled.div`
  border-bottom: 1px solid var(--bar-pink-border);
  margin-bottom: 16px;
`;

const SubTitle = styled.span`
  font-size: 18px;
  border-bottom: 3px solid var(--bar-pink-border);
`;

function SchoolGradeOlogy() {
  const [grades, setGrades] = useState([]);

  useEffect(() => {
    getGrades().then((data) => {
      setGrades(data);
    });
  }, []);

  return (
    <Wrapper>
      <Title>Tài liệu chuyên ngành</Title>
      {grades.map(({ GradeID, GradeName }) => (
        <div className="mb-[16px]">
          <SubTitleWrapper>
            <SubTitle>{GradeName}</SubTitle>
          </SubTitleWrapper>
          <Ologies gradeId={GradeID} />
        </div>
      ))}
    </Wrapper>
  );
}

export default SchoolGradeOlogy;
